import { render, staticRenderFns } from "./ListArticle.vue?vue&type=template&id=eeb7eec6&"
import script from "./ListArticle.vue?vue&type=script&lang=js&"
export * from "./ListArticle.vue?vue&type=script&lang=js&"
import style0 from "./ListArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListArticleItem: require('/app/components/list/ListArticleItem.vue').default})
